import React, { useState, useEffect } from 'react'
import Loader from '../../component/loader/Loader'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { IoRefreshOutline } from 'react-icons/io5'
import Flatpickr from 'react-flatpickr'
import "flatpickr/dist/themes/light.css"
import { LuChevronLeft, LuChevronRight, LuPrinter } from 'react-icons/lu'
import { FaRegFileExcel } from 'react-icons/fa6';
import DataTablePagination from '../../component/data_table/DataTablePagination';
import { useFormik } from 'formik';
import SaveButton from '../../component/buttons/SaveButton';
import { ProductListRes, ProductListTodo } from '../../redux/Slices/Product/ProductList';
import Select from 'react-select'
import { CategoryListRes, CategoryListTodo } from '../../redux/Slices/Category/CategoryList';
import { Button } from 'react-bootstrap';
import xlsx from "json-as-xlsx"
import ProductListPdf from './ProductListPdf';

export default function ProductList() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const [pageLimit, setPageLimit] = useState(800)
    const [tableLoading, setTableLoading] = useState(false)
    const [pageSize, setPageSize] = useState(1)
    const [productData, setProductData] = useState([])
    const [pdfModal, setPdfModal] = useState(false)
    const [filterLoad, setFilterLoad] = useState(false)
    //  console.log(loading)
    const product_list = useSelector(state => state?.ProductList?.data?.data)
    console.log(product_list)
    // const TotalCount = useSelector(state => state?.ProductList?.data?.list_size)
    const Category = useSelector(state => state?.CategoryList?.data?.data)

    const category_option = Category && Category.map(val => (
        { "value": val.citem_category_short_name, "label": val.vitem_category_name }
    ));

    const initialValues = {
        search: '',
        group: ''
    }

    let mobileScreen = window.screen.width <= 992;


    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,

        onSubmit: (values, action) => {

            setFilterLoad(true)
            dispatch(ProductListTodo({ "search": values.search, "group": values.group, "pageLimit": pageLimit, "pageSize": pageSize })).then(() => filter_res())
        }
    })

    const handleSearch = (data) => {
        setTableLoading(true)
        dispatch(ProductListTodo({ "search": data, "group": values.group, "pageLimit": pageLimit, "pageSize": pageSize })).then(() => filter_res2())
    }
    const PageSizeFun = (data) => {
        setTableLoading(true)
        setPageLimit(data)
        dispatch(ProductListTodo({ "search": values.search, "group": values.group, "pageLimit": data, "pageSize": 1 })).then(() => filter_res2())
    }

    const nextPageFun = () => {
        setTableLoading(true)
        setPageSize(prev => prev + 1);
        dispatch(ProductListTodo({ "search": values.search, "group": values.group, "pageLimit": pageLimit, "pageSize": pageSize })).then(() => filter_res2())
    }
    const prevPageFun = () => {
        setTableLoading(true)
        setPageSize(prev => prev - 1);
        dispatch(ProductListTodo({ "search": values.search, "group": values.group, "pageLimit": pageLimit, "pageSize": pageSize })).then(() => filter_res2())
    }

    const handleReset = () => {
        values.search = ''
        setFieldValue('group', "");   // Reset search
        setBool(!bool);                // Toggle bool state if necessary

    };

    const filter_res2 = () => {
        if (ProductListRes?.status) {
            setTableLoading(false)
        } else {
            setTableLoading(false)

        }
    }

    const filter_res = () => {
        if (ProductListRes && ProductListRes.status) {
            setFilterLoad(false)
        } else {
            setFilterLoad(false)
        }
    }

    useEffect(() => {
        if (pageLimit > 800 || pageSize > 1) {
            dispatch(ProductListTodo({ "search": values.search, "group": values.group, "pageLimit": pageLimit, "pageSize": pageSize }))
        }
    }, [pageLimit, pageSize])

    useEffect(() => {
        setLoading(true)
        dispatch(CategoryListTodo()).then(() => listRes())
        // dispatch(ProductListTodo({ "search": values.search, "group": values.group, "pageLimit": pageLimit, "pageSize": pageSize })).then(() => productListFun())
    }, [bool])

    // const productListFun = () => {
    //     if (ProductListRes && ProductListRes.status) {
    //         setLoading(false)

    //     } else {
    //         setLoading(false)
    //     }
    // }

    const listRes = () => {
        if (CategoryListRes?.status) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }



    // ----------------------------------EXCEL DOWNLOAD CODE --------------------------------------

    const productListExcel = []

    const productListExcelRender = product_list?.map((value, index) => productListExcel.push({
        "Sn": index + 1,
        "vitem_name": value.vitem_name,
        "mweight": value.mweight + ' ' + value.vunit_short_name,
        "vsecondary_unit": value.vsecondary_unit,
        "vgroup_short_name": value.vgroup_short_name,
        "mrate": value.mrate + ' ' + value?.vunit_short_name,
        // "mmrp_rate": value.mmrp_rate.toFixed(2),
        // "mmrp_discount": value.mmrp_discount.toFixed(2),
        // "mrate": value.mrate.toFixed(2),
        // "mtotal_amt": value.mtotal_amt.toFixed(2),
        // "remark": value.cost,
    }))

    const downloadFile = () => {
        // const totalAmt = issueReportList?.reduce((acc, item) => acc + item.mtotal_amt, 0);
        let exceldata = [
            {
                columns: [
                    { label: "S.NO.", value: "Sn" },
                    { label: "PRODUCT NAME", value: "vitem_name" },
                    { label: "UNIT", value: "mweight" },
                    { label: "SECONDRY UNIT", value: "vsecondary_unit" },
                    { label: "GROUP", value: "vgroup_short_name" },
                    { label: "RATE", value: "mrate" },
                ],
                content: productListExcel
            },
        ]
        let settings = {
            fileName: "ExcelSheet1",
        }
        xlsx(exceldata, settings)
    }

    const handlePdf = () => {
        setPdfModal(true)
        setProductData(product_list)
    }

    const columnDefs = [
        {
            headerName: 'S.NO',
            field: 'filedName',
            valueGetter: `${pageLimit * pageSize} + (node.rowIndex + 1) - ${pageLimit}`,
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 70
        },
        {
            headerName: 'PRODUCT NAME',
            field: 'vitem_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            width:'450px'
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'UNIT',
            field: 'mweight',
            cellRenderer: params => <span>{params?.data?.mweight + ' ' + params?.data?.vunit_short_name}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            width:'150px'

            // wrapText: true,
            // autoHeight: true,
        },


        {
            headerName: 'SEC. UNIT',
            field: 'vsecondary_unit',
            cellRenderer: params => <span>{params?.data?.vsecondary_unit}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            width:'150px'

            // wrapText: true,
            // autoHeight: true,

        },
        {
            headerName: 'GROUP',
            field: 'vgroup_short_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            // maxWidth: 200
        },
        {
            headerName: 'RATE',
            field: 'mrate',
            cellRenderer: params => <span>{params?.data?.mrate + ' ' + params?.data?.vunit_short_name}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            width:'150px'

            // wrapText: true,
            // autoHeight: true,
        },


    ]

    return (

        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">

                        <div className='layout_head'>
                            <h5> Product List</h5>
                        </div>
                        {loading ?
                            <div className='mt-5 pt-5'>
                                <Loader />
                            </div>
                            :
                            <div>
                                <div className='row'>
                                    <div className='col-md-8'>
                                        <form onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-4 mb-1">
                                                    {/* <label htmlFor="" className='form_label'>Item Name </label> */}
                                                    <input
                                                        type="text"
                                                        id="filter-text-box"
                                                        placeholder='Search Item'
                                                        name='search'
                                                        //   onChange={(e) => handleSearch(e.target.value)}
                                                        value={values.search}
                                                        onChange={(e) => {
                                                            setFieldValue('search', e.target.value);
                                                            handleSearch(e.target.value)
                                                        }}
                                                        className="form-control form_input"
                                                        onBlur={handleBlur}
                                                    />
                                                </div>
                                                <div className='col-md-4 mb-1' >
                                                    {/* <label htmlFor="" className='form_label'> Category </label> */}
                                                    <Select
                                                        closeMenuOnSelect={true}
                                                        placeholder='Select Category'
                                                        options={category_option}
                                                        className='react_select'
                                                        // ref={selectSchemRef}
                                                        classNamePrefix="select"
                                                        isClearable
                                                        name="group"
                                                        onChange={(e) => {
                                                            setFieldValue("group", e?.value)
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                </div>

                                                <div className="col-md-3 mb-1">
                                                    <div className={mobileScreen ? 'd-flex justify-content-end align-items-center' : 'd-flex align-items-center'}>
                                                        <SaveButton name={'Filter'} />
                                                        <button className='ms-1 refresh_btn' onClick={handleReset} ><IoRefreshOutline style={{ color: 'white' }} size={25} /></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="col-md-4 ">
                                       {    product_list?.length ?  <div className='d-flex justify-content-end align-items-center'>
                                            <Button variant='primary' size='sm' onClick={() => handlePdf()}>
                                                Print <LuPrinter />
                                            </Button>
                                            <Button className='ms-2' variant='primary' size='sm' onClick={() => downloadFile()} >
                                                Excel Download <FaRegFileExcel />
                                            </Button>
                                        </div>:''}
                                    </div>

                                </div>
                                <div >
                                    {
                                        filterLoad ?
                                            <div className='mt-5'>
                                                <Loader />
                                            </div> :
                                          product_list?.length ?
                                                <div className='mt-2'>
                                                    <DataTablePagination
                                                        rowData={product_list && product_list}
                                                        columnDefs={columnDefs}
                                                        loading={tableLoading}
                                                        height={'60vh'}
                                                    />
                                                    <div className='text-end pgn_tbl_footer mb-2'>
                                                        <div className='d-flex justify-content-end align-items-center'>
                                                            <div className="d-flex align-items-center">
                                                                <label htmlFor="" className="form-label form_label" style={{ marginBottom: 0 }}>Page Size</label>
                                                                <select className="form-select form_input ms-2" style={{ width: '12vh' }} onChange={(e) => { PageSizeFun(e.target.value) }}>
                                                                    <option value="10">10</option>
                                                                    <option value="20">20</option>
                                                                    <option value="50">50</option>
                                                                    <option value="100">100</option>
                                                                    <option value="150">150</option>
                                                                    <option value="200">200</option>
                                                                </select>
                                                            </div>
                                                            <div className='d-flex align-items-center ms-3 table_footer_pagination' style={{ marginRight: '15px' }}>
                                                                <button type='button' disabled={pageSize === 1 ? true : false} onClick={() => { prevPageFun() }} className='btn pg_btn'><span className='me-2'><LuChevronLeft style={{ marginBottom: '2px' }} size={20} /></span></button>
                                                                <p><span>{pageLimit * pageSize - pageLimit + 1}</span> to <span>{pageLimit * pageSize - pageLimit + product_list?.length}</span></p>
                                                                <button type='button' disabled={product_list?.length < pageLimit ? true : false} onClick={() => { nextPageFun() }} className='btn pg_btn'>   <span className='ms-2'><LuChevronRight style={{ marginBottom: '2px' }} size={20} /></span></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> :
                                                <div className='empty_section mt-3'>
                                                    <span>DATA NOT FOUND</span>
                                                </div>
                                    }
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
            <ProductListPdf pdfModal={pdfModal} setPdfModal={setPdfModal} productData={productData} />
        </>
    )
}
